module.exports = {
    pathValue: true,
    pathSyntax: true,
    json: true,
    jsonGraph: true
};

